<template>
    <div class="tab-item">
        <!-- Menu Tabs -->
        <SubNav :tab="tab" @change="setTab" />

        <template v-if="tab">
            <LeaderboardUsers :tab="tab" />
        </template>
    </div>
</template>

<script>
import SubNav from '@/components/panel/Leaderboard/SubNav.vue'
import LeaderboardUsers from '@/components/panel/Leaderboard/LeaderboardUsers.vue'
import { ref } from 'vue'
export default {
    name: 'LeaderboardTab',
    components: {
        SubNav,
        LeaderboardUsers
    },
    setup() {
        const tab = ref(1);

        const setTab = (val) => {
            tab.value = val
        }

        return {
            tab,
            setTab
        }
    },
}
</script>